import React from 'react';
import { connect } from 'react-redux';
import { finishedLoginsType } from '../initialStoreValues';

import InstitutionPicker from './InstitutionPicker';
import FinishedLoginsList from './FinishedLoginsList'; // ✅ Import global component
import { submitAll } from '../actions';
import actions from '../constants/actions';

class FinishedInstitutionLogins extends React.Component {
    render() {
        const { finishedLogins, theme, withPicker, dispatch } = this.props;

        if (finishedLogins.list.length > 0) {
            const containsOnlyWinz = finishedLogins.list.every(item => item.slug === 'winz');
            const addAnotherInstitutionBtnText = containsOnlyWinz ? "Add Bank" : theme.text.addAnotherInstitutionBtn;

            return (
                <>
                    <div className="form-group">
                        <h2 className="d-flex justify-content-center">
                            {finishedLogins.list.length > 1
                                ? theme.text.completedInstitutionsTitleMultipleInstitutions
                                : theme.text.completedInstitutionsTitleOneInstitution}
                        </h2>
                    </div>

                    {/* Use global FinishedLoginsList */}
                    <FinishedLoginsList finishedLogins={finishedLogins} />

                    {withPicker !== true ? (
                        <AddAnotherBank
                            onClick={() => dispatch({ type: actions.ADD_ANOTHER_INSTITUTION })}
                            text={addAnotherInstitutionBtnText}
                        />
                    ) : null}

                    {withPicker === true ? <InstitutionPicker pickerOnly={true} /> : null}

                    <SubmitAll
                        onClick={() => dispatch(submitAll())}
                        text={theme.text.submitAllBtn}
                    />
                </>
            );
        } else {
            return <InstitutionPicker pickerOnly={false} />;
        }
    }
}

const AddAnotherBank = (props) => (
    <div className="form-group">
        <button className="form-control btn btn-primary" onClick={props.onClick} type="button">
            {props.text}
        </button>
    </div>
);

const SubmitAll = (props) => (
    <div className="form-group">
        <button className="form-control btn btn-secondary" onClick={props.onClick} type="button">
            {props.text}
        </button>
    </div>
);

FinishedInstitutionLogins.propTypes = {
    finishedLogins: finishedLoginsType.isRequired
};

const mapStateToProps = (state) => ({
    theme: state.common.theme,
    finishedLogins: state.finishedLogins
});

export default connect(mapStateToProps)(FinishedInstitutionLogins);